import { client } from 'app/http';

export const clearSsoProviderSession = async () => {
  await client.delete('/auth/sso/session');
};
